var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t("prepend"),
      _vm._v(" " + _vm._s(_vm.formatDate(_vm.value, "DD.MM.YYYY")) + " | "),
      _c("span", { staticClass: "grey--text" }, [
        _vm._v(_vm._s(_vm.formatDate(_vm.value, "HH:mm:ss"))),
      ]),
      _vm._t("append"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }